import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ProductionBoardService } from 'src/app/services/production-board/production-board.service';

@Component({
	selector: 'app-inventory-control',
	templateUrl: './inventory-control.component.html',
	styleUrls: ['./inventory-control.component.scss'],
})
export class InventoryControlComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;
	@ViewChild('sheetWeek', { static: true }) sheetWeek: ElementRef;
	// private campaingUpdate: InventoryControl = new InventoryControl(3,'',0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,'',0,0);

	constructor(private inventoryControl: ProductionBoardService) {}

	ngAfterViewInit(): void {
		var promise = Promise.resolve(
			this.inventoryControl.getProductionBoard(),
		);
		promise.then((value) => {
			var tableDaily = jspreadsheet(this.sheet.nativeElement, {
				data: value.body,
				csvHeaders: true,
				search: true,
				pagination: 25,
				tableOverflow: true,
				freezeColumns: 2,
				tableWidth: '1100px',
				tableHeight: '1100px',
				columns: [
					{ type: 'hidden', title: 'Id', width: 90 }, //-- 0 A
					{ type: 'text', title: 'Account', width: 90 }, //-- 0 A
					{
						type: 'numeric',
						title: 'Lead Cost',
						width: 90,
						mask: '$#,##.00',
						decimal: '.',
					}, //-- 1 B
					{ type: 'numeric', title: 'Weekly Order', width: 90 }, //-- 2 C
					{ type: 'numeric', title: 'Monday', width: 90 }, //-- 3 D
					{ type: 'numeric', title: 'Tuesday', width: 90 }, //-- 4 E
					{ type: 'numeric', title: 'Wednesday', width: 90 }, //-- 5 F
					{ type: 'numeric', title: 'Thursday', width: 90 }, //-- 6 G
					{ type: 'numeric', title: 'Friday', width: 90 }, //-- 7 H
					{ type: 'numeric', title: 'Leads Produced', width: 90 }, //-- 8 I
					{ type: 'text', title: 'BILLABLES PRODUCED', width: 90 }, //-- 9 J
					{ type: 'text', title: 'Replacement Produced', width: 90 }, //-- 10 K
					{ type: 'text', title: 'Reserve', width: 90 }, //-- 11 L
					{ type: 'text', title: 'Hourly', width: 90 }, //-- 12 M
					{ type: 'text', title: 'Promo', width: 90 }, //-- 13 N
					{ type: 'text', title: 'Extra', width: 90 }, //-- 14 O
					{
						type: 'text',
						title: 'Revenue Produced',
						width: 90,
						mask: '$#,##.00',
						decimal: '.',
					}, //-- 15 P
					{ type: 'text', title: 'FREE LEADS', width: 90 }, //-- 16 Q
					{ type: 'text', title: 'REPLACEMENTS', width: 90 }, //-- 17 R
					{
						type: 'text',
						title: 'Billables NOT Generated from Previous Weeks',
						width: 90,
					}, //-- 18 S
					{
						type: 'text',
						title: 'RESERVE/Hourly WEEKLY ORDER',
						width: 90,
					}, //-- 19 T
					{ type: 'text', title: 'HOURLY LEADS', width: 90 }, //-- 20 U
					{ type: 'text', title: 'BILLABLES', width: 90 }, //-- 21 V
					{ type: 'text', title: 'EXTRA2', width: 90 }, //-- 22 X
					{ type: 'text', title: 'LEADS LEFT', width: 90 }, //-- 23 Y
					{ type: 'text', title: 'REPLACEMENT LEFT', width: 90 }, //-- 24 Z
					{ type: 'text', title: 'BLLABLE LEFT', width: 90 }, //-- 25 AA
					{
						type: 'text',
						title: 'REV LEFT',
						width: 90,
						mask: '$#,##.00',
						decimal: '.',
					}, //-- 26  AB
					{ type: 'text', title: 'ACCOUNT2', width: 90 }, //-- 27 AC
					{ type: 'text', title: 'Board update', width: 90 }, //-- 28 AD
					{ type: 'text', title: 'TIMEZONE', width: 90 }, //-- 29 AE
				],
				footers: [[]],

				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {},
			});

			// ----------------------------- //

			var promiseWeek = Promise.resolve(
				this.inventoryControl.getProductionBoardWeekly(),
			);

			promiseWeek.then((valueWeek) => {
				var changed = function (
					instance: any,
					cell: any,
					x: any,
					y: any,
					value: any,
				) {
					var cellName = jspreadsheet.getColumnNameFromId([x, y]);
					var rowInt = parseInt(y) + 1;
					var WeeklyOrder = tableWeek.getLabel('M' + rowInt);
					var freeLeads = tableWeek.getLabel('G' + rowInt);
					var replacements = tableWeek.getLabel('H' + rowInt);
					var bngfpw = tableWeek.getLabel('I' + rowInt);
					var reserveHourly = tableWeek.getLabel('J' + rowInt);
					var hourlyLeads = tableWeek.getLabel('K' + rowInt);
					var billables = tableWeek.getLabel('L' + rowInt);

					if (x == 12) {
						tableDaily.setValue('D' + rowInt, WeeklyOrder, true);
					}

					if (x == 6) {
						tableDaily.setValue('R' + rowInt, freeLeads, true);
					}

					if (x == 7) {
						tableDaily.setValue('S' + rowInt, replacements, true);
					}

					if (x == 8) {
						tableDaily.setValue('T' + rowInt, bngfpw, true);
					}

					if (x == 9) {
						tableDaily.setValue('U' + rowInt, reserveHourly, true);
					}

					if (x == 10) {
						tableDaily.setValue('V' + rowInt, hourlyLeads, true);
					}

					if (x == 11) {
						tableDaily.setValue('W' + rowInt, billables, true);
					}
				};

				var tableWeek = jspreadsheet(this.sheetWeek.nativeElement, {
					data: valueWeek.body,
					csvHeaders: true,
					search: true,
					pagination: 25,
					tableOverflow: true,
					freezeColumns: 5,
					tableWidth: '1100px',
					tableHeight: '1100px',
					columns: [
						{ type: 'hidden', title: 'Id', width: 90 },
						{ type: 'numeric', title: 'AE', width: 90 },
						{ type: 'numeric', title: 'Week Started', width: 90 },
						{ type: 'numeric', title: 'Industry', width: 90 },
						{ type: 'numeric', title: 'Account', width: 90 },
						{
							type: 'numeric',
							title: 'Cost per Lead',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{ type: 'numeric', title: 'Free Leads', width: 90 },
						{
							type: 'numeric',
							title: 'Replacement Owed',
							width: 90,
						},
						{
							type: 'numeric',
							title: 'Billables NOT Generated from Previous Weeks',
							width: 90,
						},
						{ type: 'numeric', title: 'Reserve', width: 90 },
						{ type: 'numeric', title: 'Hourly', width: 90 },
						{
							type: 'numeric',
							title: 'Contracted Weekly Order',
							width: 90,
						},
						{
							type: 'numeric',
							title: 'Totaly Weekly Order',
							width: 90,
						},
						{
							type: 'numeric',
							title: 'Revenue Billables Not Generated',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{
							type: 'numeric',
							title: 'Total Value',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{
							type: 'numeric',
							title: 'Generated Approved',
							width: 90,
						},
						{ type: 'numeric', title: 'Leads Left', width: 90 },
						{
							type: 'numeric',
							title: 'On Reserve Billing?',
							width: 90,
						},
						{
							type: 'numeric',
							title: 'Starting Reserve',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{
							type: 'numeric',
							title: 'Total Value Billed',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{
							type: 'numeric',
							title: 'Reserve Left',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{
							type: 'numeric',
							title: 'Replacement Value',
							width: 90,
							mask: '$#,##.00',
							decimal: '.',
						},
						{ type: 'numeric', title: 'Notes', width: 90 },
						{
							type: 'numeric',
							title: 'Billables NOT Generated from Previous Weeks2',
							width: 90,
						},
						{
							type: 'numeric',
							title: 'REPLACEMENTS OWED3',
							width: 90,
						},
						{ type: 'numeric', title: 'FREE LEADS 4', width: 90 },
					],
					onchange: changed,
					footers: [[]],

					updateTable: function (
						instance,
						cell,
						col,
						row,
						val,
						label,
						cellName,
					) {},
				});
			});
		});
	}
}
